export default "__VITE_ASSET__BdCxJbgC__"